import { Component, effect, inject } from '@angular/core';
import { NptPageComponent, NptSharedDirectiveModule } from '@npt/sdk';

import { Wallet } from "./components/wallet/wallet";
import { CustomerInfoService } from './service/customer.service';

@Component({
  selector: 'app-root',
  imports: [
    NptPageComponent,
    NptSharedDirectiveModule,
    Wallet
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private customerService = inject(CustomerInfoService);

  constructor() { effect(() => this.customerService.setUserAttribute()); }
}
